module.exports = __webpack_public_path__ + "static/PersonWashingMirror-25fc1adfdaa7eeb60efbdfc9ed74e3e0.jpg";